const RPD_SET_SPECIALTY_CODES = "RPD_SET_SPECIALTY_CODES"
const RPD_SET_DISCIPLINES = "RPD_SET_DISCIPLINES"
const RPD_SET_FILES = "RPD_SET_FILES"

const rpdTypes = {
    RPD_SET_SPECIALTY_CODES, // Загрузка направлений подготовки
    RPD_SET_DISCIPLINES, // Загрузка дисцплин
    RPD_SET_FILES, // Загрузка файлов
}

export default rpdTypes